import { render, staticRenderFns } from "./sale-order-contact-buyer.vue?vue&type=template&id=36778306&scoped=true&"
import script from "./sale-order-contact-buyer.vue?vue&type=script&lang=js&"
export * from "./sale-order-contact-buyer.vue?vue&type=script&lang=js&"
import style0 from "./sale-order-contact-buyer.vue?vue&type=style&index=0&id=36778306&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36778306",
  null
  
)

export default component.exports